import constants from '../constants/index';

const AppActions = {
		
	hideOpenTrays: function() {
		return {
			type: constants.HIDE_OPEN_TRAYS,
			payload: {}
		}
	}
	
};

export default AppActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/app_actions.js
 **/